import { useFormState } from 'react-final-form';

import { Box } from '@occc-app/design-system';
import { EarningMechanismAwardSelector } from '@occc-app/offerHelpers/components/earning-mechanism-award-selector';
import { AwardType } from '@occc-app/offerHelpers/types';
import { useMakeOffersFilter } from '@occc-app/offerHelpers/hooks/use-make-offers-filter.hook';

import {
  ReferralProgramConfigurationValuesPaths,
  ReferralProgramConfigurationValues,
} from '../../referral-program-configuration.types';

export const SenderConfigurationForm = () => {
  const { values } = useFormState<ReferralProgramConfigurationValues>();
  const makeOffersFilter = useMakeOffersFilter();

  return (
    <Box>
      <EarningMechanismAwardSelector
        buttonTypes={[AwardType.AwardNullable, AwardType.AwardPoints, AwardType.AwardVouchers]}
        title='Give Senders'
        makeOffersFilter={makeOffersFilter}
        values={{
          awardType: values.sender.award.type,
        }}
        awardTypeFieldName={'sender.award.type' satisfies ReferralProgramConfigurationValuesPaths}
        awardPointsFieldName={
          'sender.award.points' satisfies ReferralProgramConfigurationValuesPaths
        }
        awardVoucherFieldName={
          'sender.award.voucheredOffer' satisfies ReferralProgramConfigurationValuesPaths
        }
        awardVoucherExpirationFieldName={
          'sender.award.voucheredOfferExpirationDays' satisfies ReferralProgramConfigurationValuesPaths
        }
        awardVoucherExpirationEnabled
      />
    </Box>
  );
};
